module.exports = __webpack_public_path__ + "static/media/old_outcome_version_1.4182aedf.png";